import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { editStaffProfileDetails, fetchAdminProfileDetails, fetchProfile, fetchStaffProfileDetails } from "../../../service/api";


export const getStaffProfile = createAsyncThunk(
    "profile/get",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchProfile(params)
            console.log("profile", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getStaffProfileDatails = createAsyncThunk(
    "profile/getDetails",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffProfileDetails(params)
            console.log("profile info", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const editStaffProfile = createAsyncThunk(
    "profile/edit",
    async (formData, { rejectWithValue }) => {
        console.log("formData thunk ", formData)
        try {
            const response = await editStaffProfileDetails(formData)
            if (response.status === 201) {
                console.log("edit profile", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)



const profileSlice = createSlice({
    name: "staffProfile",
    initialState: {
        staffProfile: {},
        staffProfileDetails: {},
        isLoading: false,
        actionLoader: false,
        error: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            //GET
            .addCase(getStaffProfile.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getStaffProfile.fulfilled, (state, action) => {
                state.isLoading = false;
                state.staffProfile = action.payload.data;

            })
            .addCase(getStaffProfile.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //GET DETAILS
            .addCase(getStaffProfileDatails.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getStaffProfileDatails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.staffProfileDetails = action.payload.data;

            })
            .addCase(getStaffProfileDatails.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            
            //PUT
            .addCase(editStaffProfile.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(editStaffProfile.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(editStaffProfile.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })



    }
})
export default profileSlice.reducer;